import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { SingleDatePicker } from 'react-dates'
import moment from 'moment'
import { postToLoggingService } from '../../actions/logging'
import { fetchFocusSkills } from '../Mentor/Shared/FocusSkills/API'
import {
  fetchQuest,
  submitSkills,
  fetchFrameworkSkills
} from './SkillsCheck/API'
import colors from '../../configuration/colors'
import { getGradeLevels } from '../../selectors/manifest'
import { hideModal } from '../../actions/_modal'
import Button from '../mini/Button'
import PhaseMasterCourseJourneyLevelLink from '../mini/PhaseMasterCourseJourneyLevelLink'
import ModalFullScreen from '../mini/ModalFullScreen'
import QuestIcon from '../mini/QuestIcon'
import UserAvatar from '../mini/UserAvatar'
import CloseModal from '../styled/CloseModal'
import FlexContainer from '../styled/FlexContainer'
import SkillCard from './SkillsCheck/SkillCard'
import QuestPlaceholderImage from '../../static/images/Skills/quest_placeholder.svg'
import {
  ModalContainer,
  H1Skills,
  H3Skills,
  H5Skills,
  ButtonsContainer,
  LoadingContainer
} from './SkillsCheck/_Styled'
import { LexiconContext } from '../../contexts/Lexicon'

const baseSkillCheck = Object.freeze({
  skillId: null,
  masteryRatingValue: null,
  mentorNote: null,
  studentNote: null
})

export class SkillsCheck extends Component {
  constructor(props) {
    super(props)

    this.state = {
      student: this.props.student,
      quest: null,
      skillsChecks: [],
      frameworkSkills: [],
      focusSkills: [],
      isClosing: false,
      isSubmitting: false
    }

    this.onMasteryValueChangeBound = this.onMasteryValueChange.bind(this)
    this.onSkillSelectBound = this.onSkillSelect.bind(this)
    this.addSkillsCheckClickBound = this.addSkillsCheckClick.bind(this)
    this.onTrashClickBound = this.onTrashClick.bind(this)
    this.onMentorTextChangeBound = this.onMentorTextChange.bind(this)
    this.onStudentTextChangeBound = this.onStudentTextChange.bind(this)
    this.closeTheModalBound = this.closeTheModal.bind(this)

    this._fetchQuest = fetchQuest.bind(this)
    this._fetchFrameworkSkills = fetchFrameworkSkills.bind(this)
    this._submitSkills = submitSkills.bind(this)
  }

  static contextType = LexiconContext

  async componentDidMount() {
    const { userCompiledQuestId, token, orgId } = this.props

    const quest = await this._fetchQuest(userCompiledQuestId)
    const frameworkSkills = await this._fetchFrameworkSkills(
      quest.master_course.framework_subject_id,
      quest.master_course.grade_level_id
    )

    const focusSkills = await fetchFocusSkills(
      { token, orgId },
      {
        courseSectionId: quest.course_section.id,
        levelId: quest.level.id,
        questId: quest.quest.id
      }
    )

    const skillChecks = quest.quest_framework_skills_ids.map((qfs, index) => {
      const skill = frameworkSkills.find(fs => fs.id === qfs)
      return {
        id: 'skill_check_' + index,
        skillId: skill.id,
        evidenceStatementSetId: skill.evidence_statement_set_id,
        masteryRatingValue: null,
        mentorNote: null,
        studentNote: null,
        skillName: skill.name,
        focusSkill: null,
        userQuestActivityId: null
      }
    })

    const uqaIds = quest.user_quest_activities.map(uqa => uqa.activity_id)

    const mappedFocusSkills = focusSkills
      .filter(fs => uqaIds.includes(fs.activity_id))
      .map((fs, index) => {
        const skill = frameworkSkills.find(
          fss => fss.id === fs.framework_skill_id
        )
        const userQuestActivity = quest.user_quest_activities.find(
          uqa => uqa.activity_id === fs.activity_id
        )
        return {
          id: 'skill_check_' + skillChecks.length + index,
          skillId: skill.id,
          evidenceStatementSetId: skill.evidence_statement_set_id,
          masteryRatingValue: null,
          mentorNote: null,
          studentNote: null,
          skillName: skill.name,
          focusSkill: fs,
          userQuestActivityId: userQuestActivity ? userQuestActivity.id : null
        }
      })

    this.setState(() => ({
      quest,
      frameworkSkills,
      focusSkills,
      skillsChecks:
        skillChecks.length > 0
          ? [...mappedFocusSkills, ...skillChecks]
          : [Object.assign({}, baseSkillCheck)]
    }))

    document.getElementsByClassName('animated fadeIn')[0].scrollTop = 0
  }

  render() {
    const { lexicon } = this.context
    const { dispatch, isMentor } = this.props
    const {
      student,
      quest,
      frameworkSkills,
      focusSkills,
      skillsChecks,
      isClosing,
      isSubmitting
    } = this.state

    const allowFinish = this.areAllSkillsChecksReadyToSubmit()
    const frameworkSubject = this.getFrameworkSubject(quest)

    return (
      <div className="skills-check-modal-container">
        <ModalFullScreen
          padding={'50px 0 0'}
          allowEscape
          closeCallback={this.closeTheModalBound}
          isClosing={isClosing}
          headerContents={isMentor ? this.getHeaderContents() : null}
        >
          {!isMentor && (
            <CloseModal size={18} onClick={this.closeTheModalBound} />
          )}
          <ModalContainer>
            <div style={{ position: 'relative' }}>
              <H1Skills>{lexicon.skill}s Check</H1Skills>
            </div>

            {!quest ? (
              <LoadingContainer className="loading-container small">
                <div className='loading'/>
              </LoadingContainer>
            ) : (
              <Fragment>
                <FlexContainer
                  style={{
                    marginBottom: '20px',
                    textAlign: 'left',
                    justifyContent: 'flex-start'
                  }}
                >
                  {quest ? (
                    <Fragment>
                      <QuestIcon size={40} quest={quest.quest} />
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          marginLeft: '12px'
                        }}
                      >
                        <PhaseMasterCourseJourneyLevelLink
                          dispatch={dispatch}
                          // this prop is actually expecting the enrollment
                          // TODO: separate the course/mc data sent through props rather than all as one nested object
                          masterCourse={quest}
                          level={quest.level}
                          useMasterCourseAbbreviation
                        />
                        <H5Skills>{quest.quest.name}</H5Skills>
                      </div>
                    </Fragment>
                  ) : (
                    <img
                      src={QuestPlaceholderImage}
                      alt="Quest icon placeholder"
                      style={{ height: '40px', width: '40px' }}
                    />
                  )}
                </FlexContainer>

                {skillsChecks.map((skillCheck, index, scArr) => {
                  return (
                    <SkillCard
                      key={skillCheck.id}
                      index={index}
                      isMentor={isMentor}
                      quest={quest}
                      skillCheck={skillCheck}
                      masteryRatingValue={skillCheck.masteryRatingValue}
                      onSkillSelect={this.onSkillSelectBound}
                      onMasteryValueChange={this.onMasteryValueChangeBound}
                      onMentorTextChange={this.onMentorTextChangeBound}
                      onStudentTextChange={this.onStudentTextChangeBound}
                      onTrashClick={this.onTrashClickBound}
                      selectedSkills={skillsChecks.map(s => ({
                        skillId: s.skillId,
                        focusSkill: s.focusSkill
                      }))}
                      numberOfCurrentSkillChecks={scArr.length}
                      frameworkSkills={frameworkSkills}
                      frameworkSubjectName={frameworkSubject.name}
                      focusSkills={focusSkills}
                    />
                  )
                })}

                <ButtonsContainer>
                  {!isSubmitting ? (
                    <Fragment>
                      <Button
                        style={{
                          marginRight: '30px',
                          background: colors.smoke
                        }}
                        className="quest-text-btn"
                        text="+ Add Skill"
                        onClick={this.addSkillsCheckClickBound}
                      />
                      <Button
                        className={`quest-btn btn-a ${
                          !allowFinish ? 'disabled' : ''
                        }`}
                        text="Finish"
                        onClick={allowFinish ? this._submitSkills : null}
                      />
                    </Fragment>
                  ) : (
                    <LoadingContainer className="loading-container small">
                      <div className='loading'/>
                    </LoadingContainer>
                  )}
                </ButtonsContainer>
              </Fragment>
            )}
          </ModalContainer>
        </ModalFullScreen>
      </div>
    )
  }

  getHeaderContents() {
    const { student, isMentor } = this.props
    return (
      <FlexContainer
        style={{
          height: '100%',
          justifyContent: 'flex-start',
          alignItems: 'center'
        }}
      >
        {student ? (
          <Fragment>
            <UserAvatar
              size={38}
              borderRadius={5}
              photoUrl={this.props.student.photo_url}
            />
            <H3Skills lato light>
              {this.props.student.name}
            </H3Skills>
          </Fragment>
        ) : null}

        {isMentor && (
          <div style={{ marginLeft: '20px' }}>
            <SingleDatePicker
              id="skillCheckDateFilter"
              date={moment(this.state.date)}
              numberOfMonths={1}
              readOnly
              hideKeyboardShortcutsPanel
              focused={this.state.focused}
              onDateChange={this.onDateChange.bind(this)}
              displayFormat={this.getDisplayFormat.bind(this)}
              onFocusChange={this.onFocusChange.bind(this)}
              isOutsideRange={this.isOutsideRange.bind(this)}
            />
          </div>
        )}

        <CloseModal size={18} onClick={this.closeTheModalBound} />
      </FlexContainer>
    )
  }

  onDateChange(date) {
    this.setState({ date })
  }

  onFocusChange({ focused }) {
    this.setState({ focused })
  }

  isOutsideRange(day) {
    return (
      day.isAfter(moment().local().startOf('date').add(1, 'days')) ||
      day.isBefore(
        moment
          .unix(this.state.quest.course_section.start_at)
          .local()
          .startOf('day')
      )
    )
  }

  getDisplayFormat() {
    return moment(this.state.date).isSame(moment(), 'day')
      ? '[Today,] D MMMM YYYY'
      : 'D MMMM YYYY'
  }

  closeTheModal() {
    const { dispatch, actionOnClose } = this.props

    this.setState({
      isClosing: true
    })

    setTimeout(() => {
      dispatch(hideModal())

      if (actionOnClose) {
        if (actionOnClose.action) {
          dispatch(actionOnClose.action(actionOnClose.dataObject))
        } else {
          actionOnClose()
        }
      }
    }, 500)
  }

  onSkillSelect(selectedOption, index) {
    const skillsChecks = this.state.skillsChecks.splice(0)
    skillsChecks[index].skillId = selectedOption.value
    skillsChecks[index].skillName = selectedOption.label
    skillsChecks[index].evidenceStatementSetId =
      selectedOption.evidenceStatementSetId
    skillsChecks[index].focusSkill = selectedOption.focusSkill
    skillsChecks[index].userQuestActivityId = selectedOption.userQuestActivityId

    this.setState({
      skillsChecks: skillsChecks
    })
  }

  onMasteryValueChange(value, index) {
    const skillsChecks = this.state.skillsChecks.splice(0)
    // scale is 0 to 5, but .1 is actually the lowest allowed value
    // the scale starts at 0 for the visual factor of the tick marks
    // aligning to the correct values
    skillsChecks[index].masteryRatingValue = value < 0.1 ? 0.1 : value

    this.setState({
      skillsChecks: skillsChecks
    })
  }

  onMentorTextChange(value, index) {
    const skillsChecks = this.state.skillsChecks.splice(0)
    skillsChecks[index].mentorNote = value

    this.setState({
      skillsChecks: skillsChecks
    })
  }

  onStudentTextChange(value, index) {
    const skillsChecks = this.state.skillsChecks.splice(0)
    skillsChecks[index].studentNote = value

    this.setState({
      skillsChecks: skillsChecks
    })
  }

  onTrashClick(index) {
    if (this.state.skillsChecks.length > 1) {
      const skillsChecks = this.state.skillsChecks.slice(0)
      skillsChecks.splice(index, 1)

      this.setState({
        skillsChecks: skillsChecks
      })
    }
  }

  addSkillsCheckClick() {
    const skillsChecks = this.state.skillsChecks.slice(0)
    skillsChecks.push(
      Object.assign({ id: Math.random() * (100000 - 0) + 0 }, baseSkillCheck)
    )

    this.setState({
      skillsChecks: skillsChecks
    })
  }

  areAllSkillsChecksReadyToSubmit() {
    let isReady = true

    this.state.skillsChecks.forEach(s => {
      if (!s.skillId || !s.masteryRatingValue) {
        isReady = false
      }
    })

    return isReady
  }

  _getBaseLoggingData() {
    const { isMentor } = this.props
    const { quest } = this.state

    return {
      self_assessment: !isMentor,
      // student only present for mentors, and it may not be pre-selected
      student: isMentor
        ? {
            id: this.state.student.id,
            name: this.state.student.name
          }
        : null,
      quest: quest
        ? {
            id: quest.quest.id,
            name: quest.quest.name
          }
        : null,
      compiled_quest: quest
        ? {
            id: quest.compiled_quest_id
          }
        : null,
      course: quest
        ? {
            id: quest.course.id,
            name: quest.course.name
          }
        : null,
      course_section: quest
        ? {
            id: quest.course_section.id,
            name: quest.course_section.name
          }
        : null,
      master_course: quest
        ? {
            id: quest.master_course.id,
            name: quest.master_course.name
          }
        : null
    }
  }

  _logSubmit() {
    const data = this._getBaseLoggingData()
    data.action = 'submit'
    data.skill_check_count = this.state.skillsChecks.length

    data.skill_check_date = this.state.date
      ? this.state.date.format('YYYY-MM-DD')
      : moment().format('YYYY-MM-DD')

    data.skill_framework_version = 2

    this.props.dispatch(postToLoggingService('skill_checks_combined', data))
  }

  getMasteryLevel(skillsCheck) {
    const rating = Math.round(skillsCheck.masteryRatingValue * 10) / 10
    if (rating <= 1) {
      return 'Not Familiar'
    } else if (rating <= 2) {
      return 'Familiar'
    } else if (rating <= 3) {
      return 'Developing'
    } else if (rating <= 4) {
      return 'Proficient'
    } else {
      return 'Mastering'
    }
  }

  getFrameworkSubject(quest) {
    return quest
      ? this.props.frameworkSubjects.find(
          s => s.id === quest.master_course.framework_subject_id
        )
      : null
  }
}

SkillsCheck.propTypes = {
  // mapped props
  dispatch: PropTypes.func,
  orgId: PropTypes.number,
  token: PropTypes.string,
  gradeLevels: PropTypes.array,
  // props passed directly
  source: PropTypes.string,
  student: PropTypes.object,
  userCompiledQuestId: PropTypes.number,
  isMentor: PropTypes.bool,
  courseSection: PropTypes.object, // only passed in one instance,
  actionOnClose: PropTypes.object,
  frameworkSubjects: PropTypes.array
}

export function mapStateToProps(state) {
  return {
    orgId: state.organization.orgId,
    token: state.auth.token,
    gradeLevels: getGradeLevels(state),
    frameworkSubjects: state.manifest.data.framework_subjects
  }
}

export default connect(mapStateToProps)(SkillsCheck)
